// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IP77","icon":"styles_icon__3zGY5"};